var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "28 16 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_twitter)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16,
    width: 20,
    height: 20,
    rx: 8,
    fill: "url(#paint0_linear_twitter)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_twitter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0841 21.5991C44.5597 21.8295 43.9996 21.9865 43.41 22.0581C44.0109 21.6963 44.4731 21.1259 44.6918 20.4454C44.1282 20.7741 43.5036 21.0134 42.8387 21.1466C42.3077 20.5787 41.551 20.2233 40.7106 20.2233C39.1005 20.2233 37.795 21.5281 37.795 23.1355C37.795 23.3665 37.8217 23.5886 37.8702 23.8012C35.4465 23.6869 33.2982 22.5237 31.8606 20.7652C31.6075 21.1928 31.4659 21.6898 31.4659 22.2311C31.4659 23.2439 31.9814 24.1341 32.7625 24.657C32.2843 24.6416 31.8345 24.5101 31.4422 24.2922V24.3283C31.4422 25.7409 32.4455 26.9189 33.7806 27.1872C33.5359 27.2529 33.2775 27.2885 33.0126 27.2885C32.8265 27.2885 32.6481 27.2707 32.4698 27.2375C32.8437 28.3942 33.9187 29.2376 35.1982 29.2613C34.2026 30.0425 32.9409 30.5081 31.582 30.5081C31.3509 30.5081 31.1204 30.4944 30.8887 30.4684C32.1859 31.294 33.7143 31.7767 35.367 31.7767C40.7326 31.7767 43.663 27.337 43.663 23.4932C43.663 23.3694 43.663 23.2445 43.6541 23.1201C44.2236 22.712 44.7208 22.1961 45.112 21.611L45.0841 21.5991Z",
    fill: "url(#paint1_linear_twitter)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_twitter",
    x: 4,
    y: 4,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_twitter",
    x: 0.888672,
    y: 0.223297,
    width: 74.2233,
    height: 71.5534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_twitter",
    x1: 38,
    y1: 16,
    x2: 38,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C85CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_twitter",
    x1: 38.0003,
    y1: 20.2233,
    x2: 38.0003,
    y2: 31.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.e0c86f28bf36cbf17d2458d12da4fd0a.svg";
export { ForwardRef as ReactComponent };